import { CSSProperties, FC } from 'react';
import styles from './MessageStick.module.scss';

const MessageStick: FC<{ title: string; icon: string; bg: string; animation?: boolean; style?: CSSProperties }> = ({
    title,
    icon,
    bg,
    animation,
    style = {},
}) => {
    return (
        <div
            className={`${styles.messageStick} ${animation ? styles.animation : ''}`}
            style={{ background: bg, ...style }}>
            <img
                src={icon}
                alt=""
            />
            <p>{title}</p>
        </div>
    );
};

export default MessageStick;
